import SearchIcon from "@mui/icons-material/Search";
import { Box, BoxProps } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useCallback } from "react";

interface ListSearchProps<T> extends BoxProps {
  initialRows: T[];
  searched: string;
  setRows: React.Dispatch<React.SetStateAction<T[]>>;
  setSearched: (search: string) => void;
  columnGetters: ((value: T) => string)[];
}

// 検索バーのコンポーネント
// prettier-ignore
const ListSearch = <T,>(props: ListSearchProps<T>) => {
  const { searched, initialRows, setRows, setSearched, columnGetters,...otherProps} = props;

  // 検索文字によってテーブルの行をフィルター関数
  const requestSearch = useCallback((searchedVal:string) => {
    const filteredRows = initialRows.filter((row) => {
      return columnGetters.some((getter) => {
        const columnValue = getter(row);
        return columnValue?.toLowerCase().includes(searchedVal.toLowerCase());
      });
    });
    // 再レンダリングを防ぐためオブジェクトの中身が異なるときのみ状態を更新する
    setRows((previousRows) => {
      if (JSON.stringify(previousRows) !== JSON.stringify(filteredRows)) {
        return filteredRows
      }
      return previousRows
    });
  },[columnGetters, initialRows, setRows]);

  // 検索バーの文字が変化したときにフィルターを実行する関数
  const changeSearchedHandler = (event: any) => {
    setSearched(event?.target?.value || "");
    requestSearch(event?.target?.value || "");
  };

  useEffect(() => {
    requestSearch(searched);
  }, [initialRows, requestSearch, searched]);

  return (
    <Box sx={{ display: "flex", alignItems: "center" ,...otherProps.sx}}>
      <SearchIcon />
      <TextField
        id="standard-basic"
        label="Search"
        variant="standard"
        value={searched}
        onChange={(event) => changeSearchedHandler(event)}
      />
    </Box>
  );
};
export default ListSearch;
